import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'ox-account-alert',
  templateUrl: './account-alert.component.html'
})
export class AccountAlertComponent {

  @Input() type: string;
  @Input() message: string;
  @Input() CTAUrl?: string;
  @Input() linkOrButtonText?: string;
  @Output() handleButton = new EventEmitter();
}
